import React, { useState } from "react";
import InquiryModal from "../components/InquiryModal";
import travelInsuranceImg from "../assets/images/travel-insurance.jpg";

const TravelInsurance: React.FC = () => {
  const [showInquiry, setShowInquiry] = useState(false);

  const insuranceInfo = {
    title: "Travel Insurance",
    description:
      "Protect yourself and your loved ones while traveling abroad. Our travel insurance plans provide coverage for medical emergencies, trip cancellations, lost luggage, and more.",
    features: [
      "Medical emergency coverage",
      "Trip cancellation protection",
      "Lost or delayed baggage coverage",
      "24/7 global assistance",
      "Affordable and customizable plans",
    ],
  };

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#9e9e5a",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${travelInsuranceImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "5rem 2rem",
          color: "#9e9e5a",
          textAlign: "center",
          marginBottom: "2rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ fontSize: "3rem", fontWeight: 700 }}>
          {insuranceInfo.title}
        </h1>
        <p style={{ fontSize: "1.25rem", marginTop: "1rem" }}>
          {insuranceInfo.description}
        </p>
      </div>

      {/* Features */}
      <div style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
          Why Choose Our Travel Insurance
        </h2>
        <ul style={{ paddingLeft: "1.2rem", lineHeight: 1.8 }}>
          {insuranceInfo.features.map((feature, idx) => (
            <li key={idx}>{feature}</li>
          ))}
        </ul>
      </div>

      {/* Inquiry Button */}
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <button
          onClick={() => setShowInquiry(true)}
          style={{
            padding: "0.8rem 2rem",
            backgroundColor: "#E1306C",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Send Inquiry
        </button>
      </div>

      {/* Inquiry Modal */}
      {showInquiry && (
        <InquiryModal
          show={showInquiry}
          onClose={() => setShowInquiry(false)}
          inquiryData={{
            type: "Insurance",
            name: "",
            email: "",
            phone: "",
            from: undefined,
            to: undefined,
            date: undefined,
          }}
        />
      )}
    </div>
  );
};

export default TravelInsurance;
